// @mui
import {
  Box,
  Button,
  Container,
  Grid,
  Stack,
  Typography,
} from '@mui/material'
// components
import Layout from '~/layouts'
import HeaderBreadcrumbs from 'components/HeaderBreadcrumbs'
import Page from 'components/Page'
import Image from 'components/Image'
// hooks
import useSettings from 'hooks/useSettings'
import { useBoundVerificationUserStore } from 'domains/Users/Verification/stores'
// constants
import { PATH_DASHBOARD } from 'routes/paths'
import { TERMS_CONDITION_URL } from '~/config'
// styles
import { StyledBaseContainer } from '~/commons/styled'
import config from 'configs/app'
import useLocales from 'hooks/useLocales'
import appConfig from 'configs/app'

export default function FreezePage() {
  const { t } = useLocales()
  const { personalData } = useBoundVerificationUserStore((state) => ({
    personalData: state.personalData,
  }))
  const { themeStretch } = useSettings()

  return (
    <Layout>
      <Page title={t('key_data_verification_input')}>
        <Container maxWidth={themeStretch ? false : 'xl'}>
          <HeaderBreadcrumbs
            heading={t('key_data_verification_input')}
            links={[
              { name: 'Dashboard', href: PATH_DASHBOARD.root },
              {
                name: t('key_data_verification'),
                href: PATH_DASHBOARD.general.verification.root,
              },

              {
                name: t('key_data_verification_input'),
              },
            ]}
          />
          <Box
            sx={(theme) => ({
              [theme.breakpoints.up('md')]: {
                maxWidth: '720px',
              },
              margin: '0px auto',
            })}
          >
            <StyledBaseContainer>
              <Grid container spacing={2.5}>
                <Grid container item xs={12} justifyContent="center">
                  <Image
                    alt="rejected-kyc-illustartion"
                    src={`${appConfig.assetBaseUrl}/webp/illustrations/illustration_components.webp`}
                    sx={{ width: '176px' }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Stack gap={1.5}>
                    <Typography variant="h4" textAlign="center">
                      {t('key_your_account_is_temporary_frozen')}
                    </Typography>
                    <Typography textAlign="center" variant="body2">
                      {t('key_your_account_is_currently_frozen', {
                        reason: personalData?.reject_reason,
                      })}
                    </Typography>
                  </Stack>
                </Grid>

                <Grid item xs={12}>
                  <Stack direction="row" gap={1}>
                    <Button
                      id="b-users-freezepage-terms"
                      variant="outlined"
                      sx={{ flex: 1 }}
                      onClick={() => {
                        window.open(
                          `${TERMS_CONDITION_URL}#Aplikasi,-Akun-dan-Keamanan`,
                          '_blank',
                        )
                      }}
                    >
                      {t('key_terms_and_conditions')}
                    </Button>
                    <Button
                      id="b-users-freezepage-contact-cs"
                      variant="contained"
                      sx={{ flex: 1 }}
                      onClick={() => {
                        window.open(
                          config.supportCenterUrl + 'home',
                          '_blank',
                        )
                      }}
                    >
                      {t('key_contact_cs')}
                    </Button>
                  </Stack>
                </Grid>
              </Grid>
            </StyledBaseContainer>
          </Box>
        </Container>
      </Page>
    </Layout>
  )
}
